module.exports = __webpack_public_path__ + "img/we-qrcode.4bee6de9.png";